// news公共方法
import Vue from 'vue';

// html 内容转纯文本
function ToText(HTML) {
    var input = HTML;
    return input
        .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
        .replace(/<[^>]+?>/g, '')
        .replace(/\s+/g, ' ')
        .replace(/ /g, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/>/g, ' ');
}


// 时间格式化
function toTime(num , isHour = true) { //时间戳数据处理
    let date = new Date(num * 1);
    
    //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM; //月补0
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d; //天补0
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h; //小时补0
    let m = date.getMinutes();
    m = m < 10 ? ('0' + m) : m; //分钟补0
    let s = date.getSeconds();
    s = s < 10 ? ('0' + s) : s; //秒补0

    if(isHour) {
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m+ ':' + s; //年月日时分秒
    } else{
        return y + '-' + MM + '-' + d; //年月日
    }
}

export {
    ToText,
    toTime,
}

